export default __webpack_public_path__ + "static/media/india.613de6af.svg";